import React, { Component } from 'react'

class PresetItem extends Component {

  _onClick = () => {
    const { item, onClick } = this.props
    onClick(item.get('id'))
  }

  render() {
    const { k } = this.props
    return (
      <button onClick={this._onClick} type="button" className="btn btn-default">{k+1}</button>
    )
  }
}

export default PresetItem



// WEBPACK FOOTER //
// ./src/containers/NotePayments/preset-item.js